<template>
  <el-form
    size="small"
    class="basic-info-form"
    :label-position="$i18n.locale !== 'zh' ? 'top' : 'right'"
    :label-width="$i18n.locale !== 'zh' ? 'auto' : '120px'"
  >
    <el-row :gutter="16" type="flex" class="basic-info-row">
      <!--      快递应收-->
      <template v-if="type === 1">
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--业务单号-->
          <el-form-item :label="$t('receivablePayable.TicketNumber') + '：'">
            {{ formData.waybillNumber }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--客户单号-->
          <el-form-item :label="$t('receivablePayable.CustomerTrackingNumber') + '：'">
            {{ formData.customerNumber }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--站点-->
          <el-form-item :label="$t('basicData.Outlets') + '：'">
            {{ formData.siteName }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--客户-->
          <el-form-item :label="$t('receivablePayable.customer') + '：'">
            {{ formData.customerAlias }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--包裹类型-->
          <el-form-item :label="$t('placeOrder.packageType') + '：'">
            <span v-if="formData.orderPackageType === 1">{{ $t('placeOrder.zhifa') }}</span> <!--直单-->
            <span v-if="formData.orderPackageType === 2">{{ $t('placeOrder.CoPacking') }}</span> <!--核弹-->
            <span v-if="formData.orderPackageType === 3">{{ $t('basicData.other') }}</span> <!--其他-->
            <span v-if="formData.orderPackageType === 4">{{ $t('placeOrder.big01') }}</span> <!--大件-->
            <span v-if="formData.orderPackageType === 5">{{ $t('basicData.OneItemWithMultipleOrders') }}</span> <!--一单多件(单NFe)-->
            <span v-if="formData.orderPackageType === 6">{{ $t('basicData.OneOrderWithMultipleItems') }}</span> <!--一单多件(多NFe)-->
            <span v-if="formData.orderPackageType === 99">{{ $t('basicData.lessThanTruckloadLTT') }}</span> <!--零担-->
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--计费重量-->
          <el-form-item :label="$t('receivablePayable.BillableWeight') + '：'">
            {{ formData.chargeWeight }}
            {{
              chargeWeightSourceMap[formData.chargeWeightSource]
                ? `（${chargeWeightSourceMap[formData.chargeWeightSource]}）`
                : ''
            }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--体积(cm)-->
          <el-form-item>
            <template slot="label">
              <span style="position: relative">
                {{ $t('operationCenter.volume') + '(cm)' + '：' }}
                <el-tooltip class="QuestionMark" placement="right-end">
                  <div slot="content" style="font-size: 14px; max-width: 450px">{{ $t('operationTips.orderDimensionNote') }}</div>
                  <svg-icon icon-class="QuestionMark" />
                </el-tooltip>
              </span>
            </template>
            <span>
              {{ formData.volumn }}{{ formData.volumeFactor ? '（' + formData.volumeFactor + '）' : '' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--收件人邮编-->
          <el-form-item :label="$t('collectionCenter.Recipientzc') + '：'">
            {{ formData.receiveZipcode }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--发件人邮编-->
          <el-form-item :label="$t('collectionCenter.senderZipCode') + '：'">
            {{ formData.senderZipcode }}
          </el-form-item>
        </el-col>
      </template>
      <!--      整车-->
      <template v-else>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--订单号-->
          <el-form-item :label="$t('basicData.OrderNumber') + '：'">
            {{ formData.orderNumber }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--下单客户-->
          <el-form-item :label="$t('basicData.OrderingCustomer') + '：'">
            {{ formData.orderCustomerAlias }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--装卸类型-->
          <el-form-item :label="$t('basicData.UnloadingType') + '：'">
            {{ formData.loadingTypeAlias }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--付款方式-->
          <el-form-item :label="$t('basicData.PaymentMethod') + '：'">
            {{ formData.paymentMethodAlias }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--里程-->
          <el-form-item :label="$t('basicData.Mileage') + '：'">
            {{ formData.totalMileage }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--车型-->
          <el-form-item :label="$t('vehicle.modelLabel') + '：'">
            {{ formData.vehicleTypeAlias }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--发票金额-->
          <el-form-item :label="$t('GlobalSetObj.TheInvoiceAmount') + '：'">
            {{ formData.totalInvoiceMoney }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--体积-->
          <el-form-item :label="$t('basicData.Volume') + '：'">
            {{ formData.totalVolume }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--发件人城市-->
          <el-form-item :label="$t('collectionCenter.SenderCity') + '：'">
            {{ formData.senderCity }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--收件人城市-->
          <el-form-item :label="$t('collectionCenter.receiveCity') + '：'">
            {{ formData.receiverCity }}
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8"
          :lg="6" :xl="6"
        >
          <!--业务时间-->
          <el-form-item :label="$t('basicData.BusinessTime') + '：'">
            {{ formData.businessTime }}
          </el-form-item>
        </el-col>
      </template>
      <el-col :span="24">
        <!--备注-->
        <el-form-item :label="$t('receivablePayable.remark') + '：'">
          {{ formData.remark }}
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    addBatchFee: {
      type: Object,
      default: () => ({
        waybillNumber: '',
        customerNumber: '',
        siteName: '',
        customerAlias: '',
        orderPackageType: '',
        chargeWeight: '',
        chargeWeightSource: '',
        volumn: '',
        volumeFactor: '',
        receiveZipcode: '',
        senderZipcode: '',
        orderNumber: '',
        orderCustomerAlias: '',
        loadingTypeAlias: '',
        paymentMethodAlias: '',
        totalMileage: '',
        vehicleTypeAlias: '',
        totalInvoiceMoney: '',
        totalVolume: '',
        senderCity: '',
        receiveCity: '',
        businessTime: '',
        remark: ''
      })
    }
  },
  data() {
    return {
      formData: {},
      // 计费重量类型：0下单重量 1下单材积 2转运重量 3转运材积 4多类型
      chargeWeightSourceMap: {
        0: this.$t('receivablePayable.orderWeight'), // '下单重量'
        1: this.$t('receivablePayable.orderVolume'), // '下单材积',
        2: this.$t('receivablePayable.transitWeight'), // '转运重量',
        3: this.$t('receivablePayable.transitVolume'), // '转运材积',
        4: this.$t('receivablePayable.multipleTypes') // '多类型'
      }
    };
  },
  watch: {
    addBatchFee: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.QuestionMark {
  position: absolute;
  top: -20px;
  right: 12px;
}
.basic-info-row {
  display: flex;
  flex-wrap: wrap;

  > .el-col {
    min-width: 0;
  }
}

.basic-info-form {
  ::v-deep .el-form-item {
    margin-bottom: 12px !important;
  }

  // 标签与内容都允许换行，避免窄列下文字溢出到相邻列造成重叠
  ::v-deep .el-form-item__label,
  ::v-deep .el-form-item__content {
    line-height: 20px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  ::v-deep .el-form-item__label {
    padding: 6px 12px 6px 0;
  }

  ::v-deep .el-form-item__content {
    min-height: 32px;
    padding: 6px 0;
  }
}
</style>

